import { Permissions } from 'types/accounts/accounts.types';

export enum IUserRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
}

export enum ISignInMethod {
  EMAIL = 'email',
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
}

export interface IUser {
  _id?: string;
  sub: string;
  first_name: string;
  last_name: string;
  email: string;
  email_verified: boolean;
  sign_in_method: ISignInMethod;
  profile_picture: string;
  role: IUserRole;
  access: boolean;
  is_super_admin: boolean;
  deleted: boolean;
  permissions: Permissions | null;
  createdAt?: Date;
  updatedAt?: Date;
}
